
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D80027","d":"M0 0h512v341.3H0z"}}),_c('g',{attrs:{"fill":"#6DA544"}},[_c('path',{attrs:{"d":"M0 170.7h211.5V256H0zM300.5 170.7H512V256H300.5z"}})]),_c('path',{attrs:{"fill":"#0052B4","d":"M0 0v85.3h211.5V0h89v85.3H512V0z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z"}})]),_c('g',{attrs:{"fill":"#FFDA44"}},[_c('path',{attrs:{"d":"M300.5 341.3h-89V256H0v85.3h512V256H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z"}})])])
          )
        }
      }
    